/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';

  /**
   * Общий вид для страницы претензий.
   */
  app.ClaimsCommonView = app.View.extend({
    el: '[data-jsview="claims"] .claims',

    events: {
      'click .create-claim': 'createClaim'
    },
    run: function () {
      var that = this;
      this.listenTo(this.model, 'sync', this.removeLoader);
      this.listenTo(this.model, 'sync', function () {
        _.each(that.model.models, function (num) {
          var element = that.$('[data-claim-id=' + num.id + ']').parent(),
            claimView;

          claimView = new app.ClaimView({
            el: element,
            model: num,
            collection: that.model,
          });

          claimView.render();
        });
      });
      this.childViews.claimPaginationView = new app.GetParamPaginationView();
      this.initLoader();
    },
    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader = new app.LoaderView({
        contentWrapper: this.$('.claims-wrapper'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
      this.childViews.loader.render();
    },
    /**
     * Удалить лоадер.
     */
    removeLoader: function() {
      this.childViews.loader && this.childViews.loader.remove();
    },
    createClaim: function () {
      this.model.sync('create', this.model, {
        wait: true,
        success: function (resp) {
          app.helpers.RedirectHelper.locationAssign('/claim/' + resp.id + '/');
        }
      });
    }
  });
})();

}.call(window));